import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32d26dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "nge-tutedit",
  role: "dialog",
  "aria-label": "Edit this tutorial box"
}
const _hoisted_2 = { class: "nge-tutedit-head" }
const _hoisted_3 = { class: "nge-tutedit-where" }
const _hoisted_4 = {
  key: 0,
  class: "nge-tutedit-note"
}
const _hoisted_5 = {
  key: 1,
  class: "nge-tutedit-note nge-tutedit-note--wait"
}
const _hoisted_6 = {
  key: 2,
  class: "nge-tutedit-note"
}
const _hoisted_7 = {
  key: 3,
  class: "nge-tutedit-note"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-tutedit-label" }, "Title", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-tutedit-label" }, "Words", -1 /* HOISTED */))
const _hoisted_10 = { class: "nge-tutedit-hint" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-tutedit-label" }, "How it will look", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-tutedit-preview" }
const _hoisted_13 = { class: "nge-tutedit-preview-title" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 4,
  class: "nge-tutedit-error"
}
const _hoisted_16 = {
  key: 5,
  class: "nge-tutedit-done"
}
const _hoisted_17 = { class: "nge-tutedit-actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "nge-tutedit-back",
      onMousedown: _cache[4] || (_cache[4] = _withModifiers($event => ($setup.emit('close')), ["self"])),
      onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString($setup.name) + ", box " + _toDisplayString($props.box + 1), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "nge-tutedit-x",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('close')))
          }, "×")
        ]),
        (!$setup.approver)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Your change goes to Ames for approval. Players keep seeing the current wording until then."))
          : _createCommentVNode("v-if", true),
        ($setup.draft && $setup.approver)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.draft.by || 'An admin') + " suggested this wording (" + _toDisplayString($setup.when($setup.draft.at)) + "). Saving approves it.", 1 /* TEXT */))
          : ($setup.draft)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "A suggestion by " + _toDisplayString($setup.draft.by || 'an admin') + " is already waiting. Yours replaces it.", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        ($setup.live)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Edited by " + _toDisplayString($setup.live.by || 'an admin') + ", " + _toDisplayString($setup.when($setup.live.at)) + ".", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.title) = $event)),
          class: "nge-tutedit-input",
          maxlength: "200",
          spellcheck: "true"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.title]
        ]),
        _hoisted_9,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.words) = $event)),
          class: "nge-tutedit-area",
          rows: "9",
          spellcheck: "true"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.words]
        ]),
        _createElementVNode("div", _hoisted_10, [
          ($setup.code.kind === 'text')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("**bold**, *slanted*, [link words](https://...), and a blank line between paragraphs.")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("This box is written in HTML. Keep the tags as they are and change the words between them.")
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString($setup.title), 1 /* TEXT */),
          _createElementVNode("div", { innerHTML: $setup.preview }, null, 8 /* PROPS */, _hoisted_14)
        ]),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.done)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.done), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_17, [
          (!$setup.done)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "nge-tutedit-btn nge-tutedit-btn--save",
                disabled: $setup.busy || !$setup.words.trim() || (!$setup.changed && !($setup.approver && $setup.draft)),
                onClick: $setup.save
              }, _toDisplayString($setup.busy ? 'Saving…' : $setup.approver ? 'Save for everyone' : 'Send for approval'), 9 /* TEXT, PROPS */, _hoisted_18))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            type: "button",
            class: "nge-tutedit-btn",
            disabled: $setup.busy,
            onClick: _cache[3] || (_cache[3] = $event => ($setup.emit('close')))
          }, _toDisplayString($setup.done ? 'Close' : 'Cancel'), 9 /* TEXT, PROPS */, _hoisted_19),
          ($setup.approver && $setup.live && !$setup.done)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "nge-tutedit-btn nge-tutedit-btn--quiet",
                disabled: $setup.busy,
                onClick: $setup.restore
              }, "Put back the original", 8 /* PROPS */, _hoisted_20))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ], 32 /* HYDRATE_EVENTS */)
  ]))
}